module.exports = __webpack_public_path__ + "assets/img/456d40f2a1166d133ee1bda7665adeeb.png";